import { api } from './api';

export interface PermissionCatalogueItem {
  id: string;
  key: string;
  resource: string;
  action: string;
  scope: string | null;
  description: string | null;
}

export interface ChambersRole {
  id: string;
  key: string;
  name: string;
  description: string | null;
  isSystem: boolean;
  /** True only for this chambers' own custom roles — system roles are read-only. */
  editable: boolean;
  memberCount: number;
  permissionKeys: string[];
}

export async function fetchPermissionCatalogue(): Promise<PermissionCatalogueItem[]> {
  const res = await api.get('/roles/catalogue');
  return res.data.data as PermissionCatalogueItem[];
}

export async function fetchRoles(): Promise<ChambersRole[]> {
  const res = await api.get('/roles');
  return res.data.data as ChambersRole[];
}

export interface RoleMember {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  memberType: string;
  status: string;
}

export async function fetchRoleMembers(roleId: string): Promise<RoleMember[]> {
  const res = await api.get(`/roles/${roleId}/members`);
  return res.data.data as RoleMember[];
}

export async function createRole(input: {
  name: string;
  description?: string;
  permissionKeys: string[];
}): Promise<{ id: string; name: string }> {
  const res = await api.post('/roles', input);
  return res.data.data as { id: string; name: string };
}

export async function updateRole(
  id: string,
  input: { name?: string; description?: string | null; permissionKeys?: string[] },
): Promise<void> {
  await api.patch(`/roles/${id}`, input);
}

export async function deleteRole(id: string): Promise<void> {
  await api.delete(`/roles/${id}`);
}

export async function assignRole(roleId: string, userId: string): Promise<void> {
  await api.post(`/roles/${roleId}/assign`, { userId });
}

export async function revokeRole(roleId: string, userId: string): Promise<void> {
  await api.post(`/roles/${roleId}/revoke`, { userId });
}
